
define('text!templates/modules/questionnaire/edit/questionnaire-edit-content.html',[],function () { return '<div class="panel-body questionnaire-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="questionnaire-edit-form"></div>\n</div>\n';});

